import type { IDialog } from '@erp/native/interfaces';

export function createWebDialog(): IDialog {
  return {
    async show(req) {
      if (req.kind === 'confirm') {
        const ok = window.confirm(`${req.title}\n\n${req.message}`);
        return { ok };
      }
      window.alert(`${req.title}\n\n${req.message}`);
      return { ok: true };
    },
  };
}
